import { LocalisedConnectedStatus } from '../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService';
import { hasDefaultPortalStatuses } from '../constants/appsWithDefaultStatuses';

export const getAuthorizationStatuses = (
  statuses?: LocalisedConnectedStatus[]
) => {
  return Array.isArray(statuses)
    ? statuses.filter(
        ({ metadata: { category } }) => category === 'AUTHORIZATION'
      )
    : statuses;
};

type TGetStatusMapKeyArgs = Pick<
  LocalisedConnectedStatus,
  'userId' | 'externalAccountId' | 'unifiedAccountId'
>;

const getStatusesMapKey = (args?: TGetStatusMapKeyArgs) =>
  `account-${args?.externalAccountId || ''}-${args?.unifiedAccountId || ''}-${
    args?.userId || ''
  }`;

type TAccountsStatusesMap = Record<string, LocalisedConnectedStatus[]>;

export const getAccountsStatusesMap = (
  statuses?: LocalisedConnectedStatus[]
) => {
  return Array.isArray(statuses)
    ? statuses.reduce((acc, curr) => {
        const accountKey = getStatusesMapKey(curr);

        if (accountKey in acc) {
          acc[accountKey].push(curr);
        } else {
          acc[accountKey] = [curr];
        }

        return acc;
      }, {} as TAccountsStatusesMap)
    : ({} as TAccountsStatusesMap);
};

export const getMostRecentAccountsStatusesList = (
  statuses?: LocalisedConnectedStatus[]
) => {
  const accountsStatusesMap = getAccountsStatusesMap(statuses);

  const appId = statuses?.[0]?.appId;
  const mayHaveDefaults = hasDefaultPortalStatuses(appId);

  if (mayHaveDefaults) {
    const defaultPortalKey = getStatusesMapKey();
    const keysCount = Object.keys(accountsStatusesMap).length;

    if (defaultPortalKey in accountsStatusesMap && keysCount > 1) {
      delete accountsStatusesMap[defaultPortalKey];
    }
  }

  const result = Object.values(
    accountsStatusesMap || ({} as TAccountsStatusesMap)
  ).reduce((acc, curr) => {
    const sorted = curr.toSorted((s1, s2) => {
      const timestamp1 = Math.max(s1.metadata.createdAt, s1.metadata.updatedAt);
      const timestamp2 = Math.max(s2.metadata.createdAt, s2.metadata.updatedAt);

      return timestamp2 - timestamp1;
    });

    acc.push(sorted[0]);

    return acc;
  }, [] as LocalisedConnectedStatus[]);

  return result;
};
